import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'rt-assistant-cell-number',
  imports: [DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `{{ coerced() | number }}`,
  styles: [
    `
      :host {
        display: block;
        text-align: right;
        font-variant-numeric: tabular-nums;
      }
    `,
  ],
})
export class AssistantCellNumberComponent {
  public static readonly NgInputs = [<const>'value'];

  protected readonly coerced = computed<number | null>(() => {
    const v = this.value();
    if (v == null) return null;
    if (typeof v === 'number') return Number.isFinite(v) ? v : null;
    if (typeof v === 'string') {
      const n = Number(v);
      return Number.isFinite(n) ? n : null;
    }
    return null;
  });

  public readonly value = input<unknown>();
}
